import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";

export interface Announce {
    topic: string,
    message: any
}
@Injectable()
export class DataService {
    private announce: Announce = {
        topic: '',
        message: null
    };
    private loggedIn: boolean = false;
    constructor() { }

    private announcer = new BehaviorSubject<Announce>(this.announce);
    public announcement = this.announcer.asObservable();

    private userLoggedInSubject = new BehaviorSubject<boolean>(this.loggedIn);
    public userLoggedInstance = this.userLoggedInSubject.asObservable();

    doAnnouncement(announce: Announce) {
        this.announcer.next(announce);
    }

    public userLoggedIn(val: boolean) {
        this.userLoggedInSubject.next(val);
    }
}